// extracted by mini-css-extract-plugin
export default {"btn_bx":"LoginStatus_btn_bx__aS3uk","welcome":"LoginStatus_welcome__vr1NO","btn":"LoginStatus_btn__QJG5W","username":"LoginStatus_username__fQ3h3"};